import { isEmbarcacaoPropulsaoEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoPropulsao,
  EmbarcacaoPropulsaoState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const PROPULSAO_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoPropulsao> = {
  select: (ficha) => ficha.propulsao,
  isEmpty: isEmbarcacaoPropulsaoEmpty,
  secao: "a Propulsão",
};

interface UseEmbarcacaoPropulsaoResult extends EmbarcacaoPropulsaoState {
  reload: () => void;
}

/** Consulta a Propulsão da embarcação pedida. Somente leitura. */
export function useEmbarcacaoPropulsao(id: string): UseEmbarcacaoPropulsaoResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, PROPULSAO_QUERY);

  return { ...state, propulsao: data };
}
